import React from "react";
import {observer} from "mobx-react-lite";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import NavbarVertical from "./nav/navbarVertical";
import {useStores} from "../stores/useStores";
import Flex from "../components/atoms/common/flex";
import {useTranslation} from "react-i18next";
import ToastMessage from "../components/atoms/toastMessage/toastMessage";
import ButtonIcon from "../components/atoms/button/buttonIcon";
import NavigationButton from "../components/atoms/button/navigationButton";
import {IconSource} from "../shared/enums/iconSource";
import classNames from "classnames";
import "./layout.sass";

const Layout: React.FC = (props) => {
  const {
    uiStore: {modalStore, toastMessageStore}
  } = useStores();
  const {t} = useTranslation(["translation"]);
  let toggle = modalStore.canToggle ? modalStore.toggle : undefined;
  const modalConfirmButtons = modalStore.customButtons?.length ? (
    <div className="d-flex">
      {modalStore.customButtons.map((button, index) => (
        <div key={index} className="ml-3">
          <ButtonIcon
            key={button.text ?? index}
            type={button.type}
            testId={button.testId}
            onClick={button.onClick}
          >
            {button.text ?? t("translation:confirmations.defaultConfirm")}
          </ButtonIcon>
        </div>
      ))}
    </div>
  ) : (
    <div>
      <ButtonIcon
        type={modalStore.dangerButton ? "primary-negative" : "primary"}
        isDisabled={modalStore.isPrimaryButtonDisabled}
        onClick={modalStore.primaryOnClick}
        icon={modalStore.primaryButtonIcon}
        testId={modalStore.primaryButtonTestId}
      >
        {modalStore.primaryButtonText ??
          t("translation:confirmations.defaultConfirm")}
      </ButtonIcon>
    </div>
  );

  return (
    <div className="container-fluid">
      <Modal
        isOpen={modalStore.isOpen}
        toggle={toggle}
        modalClassName="theme-modal"
        contentClassName="border"
        centered={modalStore.centered}
      >
        <ModalHeader
          toggle={toggle}
          className="px-card bg-light border-0 flex-between-center"
          close={
            modalStore.canToggle ? (
              <NavigationButton icon={IconSource.exit} onClick={toggle} />
            ) : (
              <></>
            )
          }
        >
          {modalStore.header}
        </ModalHeader>
        <ModalBody className="ml-1 mr-1 modal-message">
          {modalStore.body}
        </ModalBody>
        {modalStore.isFooterVisible && (
          <ModalFooter
            tag={Flex}
            justify={modalStore.footerButtonAlignment}
            className={classNames("px-3 border-top-0", {
              "bg-light": !modalStore.hideFooterBackground
            })}
          >
            {modalStore.secondaryButtonText && (
              <div className="mr-auto">
                <ButtonIcon
                  type="secondary"
                  testId={modalStore.secondaryButtonTestId}
                  onClick={modalStore.secondaryOnClick}
                >
                  {modalStore.secondaryButtonText}
                </ButtonIcon>
              </div>
            )}
            {modalConfirmButtons}
          </ModalFooter>
        )}
      </Modal>
      <ToastMessage
        onClick={toastMessageStore.dismiss}
        isOpen={toastMessageStore.isOpen}
        message={toastMessageStore.message}
        status={toastMessageStore.status}
        header={toastMessageStore.header}
      />
      <div className="layout">
        <NavbarVertical />
        <div className="content">{props.children}</div>
      </div>
    </div>
  );
};

export default observer(Layout);
